import React from "react";
import { ArrowRight, Building2, School, UserRound } from "lucide-react";
import { useTranslation } from "react-i18next";
import Section from "../components/Section";
import SectionHeading from "../components/SectionHeading";
import { SECTION_IDS } from "../landingConfig";

/**
 * The "I am a..." path selector from the Enterprise Gateway pattern. Each card
 * carries its own micro-CTA so a visitor can self-select into the demo request.
 */
const AUDIENCES = [
  { key: "network", Icon: Building2, href: `#${SECTION_IDS.contact}` },
  { key: "director", Icon: School, href: `#${SECTION_IDS.contact}` },
  { key: "psychologist", Icon: UserRound, href: `#${SECTION_IDS.features}` },
];

export default function Audiences() {
  const { t } = useTranslation();

  return (
    <Section id={SECTION_IDS.audiences} tone="alt">
      <SectionHeading
        eyebrow={t("landing.audiences.eyebrow")}
        title={t("landing.audiences.h2")}
      />

      <div className="mt-12 grid gap-4 lg:grid-cols-3">
        {AUDIENCES.map(({ key, Icon, href }, i) => (
          <div
            key={key}
            className="landing-reveal flex h-full flex-col rounded-xl border border-line bg-white p-6"
            data-reveal-index={i}
          >
            <span className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-lg bg-gray-landing">
              <Icon className="h-5 w-5 text-primary" aria-hidden="true" />
            </span>
            <h3 className="text-xl font-semibold leading-snug text-black-landing">
              {t(`landing.audiences.${key}_title`)}
            </h3>
            <p className="mt-2 flex-1 leading-relaxed text-muted">
              {t(`landing.audiences.${key}_body`)}
            </p>
            <a
              href={href}
              className="mt-5 inline-flex min-h-11 cursor-pointer items-center gap-1.5 self-start rounded-lg text-base font-medium text-primary transition-colors duration-150 ease-out hover:text-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
            >
              {t(`landing.audiences.${key}_cta`)}
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </a>
          </div>
        ))}
      </div>
    </Section>
  );
}
